import { OK, CREATED, UNPROCESSABLE_ENTITY, UNAUTHORIZED } from '../util'

const state = {
    profileErrorsMessages: null,
    profileStatus: null,
    messaging: null,
    serviceWorkerStatus: null
}

const getters = {
}

const mutations = {
    setMessaging(state, data) {
        state.messaging = data
    },
    setServiceWorkerStatus(state, data) {
        state.serviceWorkerStatus = data
    }
}

const actions = {
    async createServiceWorker (context) {
        const firebaseConfig = {
            apiKey: "AIzaSyD_5lBhp1O_I9_slGWKcm8wfz8HwMp--es",
            authDomain: "save-pic-31781.firebaseapp.com",
            databaseURL: "https://save-pic-31781.firebaseio.com",
            projectId: "save-pic-31781",
            storageBucket: "save-pic-31781.appspot.com",
            messagingSenderId: "542166455587",
            appId: "1:542166455587:web:5a58f751c5f7027c41e896",
            measurementId: "G-YVGN285H9L"
        }
        // Initialize Firebase
        firebase.initializeApp(firebaseConfig)
        const messaging = firebase.messaging()
        messaging.usePublicVapidKey("BH6pgDrDYLZ7IenztUGbVbat85DRL38MqVZ34biT_BJlALTNOyBaGLyayARhN2Lc-SZNpRi5I1YY8KvisHjEcgE")

        messaging.requestPermission()
        context.commit('setMessaging', messaging)
    },
    async sendPushNotifKnock(context, data) {
        context.commit('setServiceWorkerStatus', null)
        const response = await axios.post('/api/service_worker/notif/knock', data)
        if (response.status === OK) {
            context.commit('setServiceWorkerStatus', true)
            return false
        }
    },
    async sendPushNotifMeeting(context, data) {
        context.commit('setServiceWorkerStatus', null)
        const response = await axios.post('/api/service_worker/notif/meeting', data)
        if (response.status === OK) {
            context.commit('setServiceWorkerStatus', true)
            return false
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}